export const names = {
	answer: 'Antwort',
	approved: 'Eingegebene Daten',
	contract: 'Vertrag',
	author: 'Autor',
	body_text: 'Text',
	birthdate: 'Geburtstag',
	buildings: 'Liegenschaft',
	callback_number: 'Rückruf Nummer',
	category: 'Kategorie',
	cc: 'Zusätzlicher Empfänger',
	cistypes: 'Z.I.S. Art',
	city: 'Stadt',
	description: 'Beschreibung',
	editor: 'Text',
	handed_keys: 'Übergebene Schlüssel',
	country: 'Land',
	currentValue: 'Aktueller Wert',
	cover_letter_text: 'Anschreiben',
	deadline: 'Frist',
	damagePosition: 'Standort / Räumlichkeit',
	damageReport: 'Kurzbeschreibung',
	damageType: 'Art des Schadens',
	date: 'Datum',
	dateMin: 'Tagesdatum',
	dateEnd: 'Datum Ende',
	dateStart: 'Datum Beginn',
	documentType: 'Dokumentenart',
	documentName: 'Dokumentenname',
	email: 'E-Mail',
	encryption: 'Verschlüsselung',
	first_name: 'Vorname',
	fileName: 'Dateiname',
	final_inspection_text: 'Text Endabnahme',
	footer_text: 'Grußformel',
	grace_period_text: 'Text Nachfrist',
	initial_inspection_text: 'Text Vorabnahme',
	inspectionType: 'Art der Abnahme',
	last_name: 'Nachname',
	location: 'Standort',
	lastValue: 'Letzter Wert',
	mailFromAddress: 'Absenderadresse',
	mailFromName: 'Absendername',
	meterReading: 'Zählerstand',
	meterNumber: 'Zählernummer',
	meterType: 'Zählerart',
	message: 'Nachricht',
	name: 'Name',
	noteType: 'Notizart',
	noteText: 'Notiztext',
	ordering: 'Sortierreihenfolge',
	password: 'Passwort',
	password_confirmation: 'Passwort Bestätigung',
	phonenumber: 'Telefonnummer',
	question: 'Frage',
	records: 'Akten',
	reportMessage: 'Nachricht',
	reportLocation: 'Standort',
	replyTo: 'Antwortadresse',
	replyToName: 'Antwortadresse Name',
	required_keys: 'Benötigte Schlüssel',
	roomComment: 'Raum Kommentar',
	roomName: 'Raum Bezeichnung',
	salutation: 'Anrede',
	senderAddress: 'Absender Adresse',
	send_reminder: 'Erinnerungsdatum',
	senderName: 'Absender Name',
	signature: 'Unterschrift',
	street: 'Straße',
	subject: 'Betreff',
	surname: 'Nachname / Firma',
	taskType: 'Wiedervorlagenart',
	template: 'Vorlage',
	text: 'Text',
	time: 'Uhrzeit',
	timeEnd: 'Uhrzeit Ende',
	timeStart: 'Uhrzeit Beginn',
	type: 'Art',
	units: 'Einheiten',
	user: 'Benutzer',
	username: 'Benutzername / E-Mail',
	validUntil: 'Sichtbar bis',
	witness: 'Zeugen',
	zip: 'Postleitzahl',
}
